import React, { ReactNode } from 'react';
import { Dialog, DialogContent } from '@/Components/shadcn/dialog';
import { ImageCropStrings } from './ImageCropUtils';
import { ImageCropContextProps } from './ImageCropContext';

export interface ImageCropDialogProps
    extends Pick<ImageCropContextProps, 'validationError'>, Pick<ImageCropStrings, 'dialogContentText'> {
    open: boolean;
    children: ReactNode;
    header: ReactNode;
    actions: ReactNode;
}

export const ImageCropDialog = ({
    open,
    children,
    header,
    actions,
    dialogContentText,
}: ImageCropDialogProps): React.JSX.Element => {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen}>
            <DialogContent
                data-cy="ImageCropDialog"
                className="m-0 flex max-w-148 flex-col p-5"
                showCloseButton={false}
            >
                <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-0">
                    <div className="flex min-h-0 flex-1 flex-col gap-2.5 overflow-auto">
                        {header}
                        <span className="text-sm">{dialogContentText}</span>
                        <div className="bg-muted flex h-60 w-138 flex-shrink-0 items-center justify-center">
                            {children}
                        </div>
                    </div>
                    <div className="flex-shrink-0">{actions}</div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
